import React from "react";
import Slider from "react-slick";
import { classNames } from "../../../helpers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Vortex } from "react-loader-spinner";

export const RenderAddressValue = ({ label, value }) => (
  <div>
    <div className="font-normal text-[12px] leading-[14px] text-[#848484] mb-[8px]">
      {label}
    </div>
    <div className="font-medium text-[14px] leading-[24px] text-[#1B1B1D] mb-[20px]">
      {value}
    </div>
  </div>
);



function VoterAddress({
  address,
  relation,
  relationship,
  expand,
  requests,
  caste,
  dob,
  family,
  service_request,
  familyLoading = false,
  serviceRequestLoading = false,
  poll
}) {
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 100,
    focusOnSelect: true,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 0.9, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 0.8, slidesToScroll: 1 } },
    ],
  };

  const getRelationDisplay = (profile) => {
    const { relationship_eng, relation_name_eng, gender } = profile;
    if (!relationship_eng || !relation_name_eng) return null;

    const relation = relationship_eng.toLowerCase();
    if (relation === "father" || relation === "mother") {
      return gender === "Male"
        ? `S/o of ${relation_name_eng}`
        : `D/o of ${relation_name_eng}`;
    }
    if (relation === "husband" && gender === "Female") {
      return `W/o ${relation_name_eng}`;
    }
    if (relation === "wife" && gender === "Male") {
      return `H/o ${relation_name_eng}`;
    }
    return `${relationship_eng} of ${relation_name_eng}`;
  };

  const isFamilyLoading = familyLoading || !Array.isArray(family);
  const isServiceLoading =
    serviceRequestLoading || !Array.isArray(service_request);

  const getPollingName = (str) => {
    if (!str) return "N/A";
    return str.split("(")[0].trim().replace(/^_/, "");
  };

  return (
    <div className={classNames(expand)}>
      <div className="px-[38px] mb-[2px]">
        <div className="flex flex-col gap-x-2">
          {caste && <RenderAddressValue label="Caste" value={caste} />}
          {dob && <RenderAddressValue label="Date of Birth" value={dob} />}
          {address && <RenderAddressValue label="Address" value={address} />}
          {relationship && (
            <RenderAddressValue
              label={`${relationship} Name`}
              value={relation}
            />
          )}
          {poll && poll.trim() !== "" && poll !== "N/A" && (
            <RenderAddressValue
              label="Polling Station"
              value={getPollingName(poll)}
            />
          )}

        </div>

        {expand && (
          <div>
            <div className="font-normal text-sm text-[#848484] mb-3">
              Family Members:
            </div>

            {isFamilyLoading ? (
              <div className="flex justify-center items-center h-[200px]">
                <Vortex
                  visible={true}
                  height={80}
                  width={80}
                  ariaLabel="vortex-loading"
                  colors={[
                    "red",
                    "green",
                    "blue",
                    "yellow",
                    "orange",
                    "purple",
                  ]}
                />
              </div>
            ) : family?.length > 0 ? (
              <div className="w-full">
                <Slider {...settings}>
                  {family.map((member) => {
                    const p = member.profile;
                    return (
                      <div key={member.id} className="px-2">
                        <div className="bg-[#f9f9f9] p-2 rounded-md shadow-sm border mb-4 flex flex-col gap-2 text-common-black text-sm">
                          <div className="flex justify-between">
                            <div className="inline-flex self-start p-1 rounded-md font-semibold bg-[#C2A3FF] text-common-white">
                              {p.voterid}
                            </div>
                            <div className="inline-flex px-2 py-1 rounded-md bg-common-black text-white">
                              <span>SL NO:&nbsp;</span>
                              {p.serialno}
                            </div>
                          </div>
                          <div>
                            <div className="font-semibold">{p.name_eng}</div>
                            <div className="text-sm">
                              {getRelationDisplay(p)}
                            </div>
                          </div>
                          <div>{p.age} Y</div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center p-6 text-center text-gray-500 bg-gray-50 rounded-lg border border-dashed border-gray-300">
                <i className="fa fa-users text-xl mb-2 text-gray-400" />
                <p className="text-sm">No family members found</p>
              </div>
            )}
          </div>
        )}

        {requests && (
          <div>
            <div className="font-normal text-sm text-[#848484] mb-3">
              Service Requests:
            </div>

            {isServiceLoading ? (
              <div className="flex justify-center items-center h-[200px]">
                <Vortex
                  visible={true}
                  height={80}
                  width={80}
                  ariaLabel="vortex-loading"
                  colors={[
                    "red",
                    "green",
                    "blue",
                    "yellow",
                    "orange",
                    "purple",
                  ]}
                />
              </div>
            ) : service_request?.length > 0 ? (
              <div className="w-full">
                <Slider {...settings}>
                  {service_request.map((request) => (
                    <div key={request.id} className="px-2">
                      <div className="bg-[#f9f9f9] p-3 rounded-md shadow-sm border mb-4 flex flex-col gap-2 text-common-black text-sm">
                        <div className="flex justify-between">
                          <div className="inline-flex self-start p-1 rounded-md font-semibold bg-[#C2A3FF] text-common-white">
                            ID: {request.id}
                          </div>
                          <div className="inline-flex px-2 py-1 rounded-md bg-common-black text-white">
                            <span>Status:&nbsp;</span>
                            {request.status}
                          </div>
                        </div>
                        <div>
                          <div className="font-semibold">
                            Type: {request.request_type}
                          </div>
                          <div className="text-sm">
                            Category: {request.category}
                          </div>
                          <div className="text-sm">
                            Subcategory: {request.subcategory}
                          </div>
                        </div>
                        <div className="text-sm">
                          Requested Date: {request.requested_date}
                        </div>
                        <div className="text-sm">
                          Enquiry: {request.enquiry} Times
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center p-6 text-center text-gray-500 bg-gray-50 rounded-lg border border-dashed border-gray-300">
                <i className="fa fa-file-alt text-xl mb-2 text-gray-400" />
                <p className="text-sm">No service requests available</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default VoterAddress;
